/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const fullName = barber => `${barber.firstName} ${barber.lastName}`;

class PickBarber extends Component {
  onChange = (e) => {
    const { value } = e.target;
    const selectedBarber = this.props.barbers.find(b => b.route === value);
    this.props.onSelectedBarberChange(selectedBarber || null);
  };

  renderBarbers() {
    const { barbers } = this.props;
    return barbers.map(barber => (
      <option
        key={barber.route}
        value={barber.route}
      >
        {fullName(barber)}
      </option>
    ));
  }

  render() {
    const { selectedBarber } = this.props;
    return (
      <div className="u-position-relative">
        <select
          className="c-btn c-btn--secondary u-1/1"
          onChange={this.onChange}
          value={selectedBarber ? selectedBarber.route : null}
        >
          <option selected disabled>
            Select a Professional
          </option>
          {this.renderBarbers()}
        </select>
      </div>
    );
  }

}

PickBarber.propTypes = {
  selectedBarber: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  barbers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  })).isRequired,
  onSelectedBarberChange: PropTypes.func.isRequired,
};

PickBarber.defaultProps = {
  selectedBarber: null,
};

export default PickBarber;



// WEBPACK FOOTER //
// ./src/app/giftCard/Checkout/GiftCard/PickBarber.jsx